import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FacebookMessengerShareButton, TwitterShareButton } from "react-share";

function WebShare({ Url, text }) {
  const { t } = useTranslation();

  return (
    <div className="sharebiography_footer">
      <h3>{t("text.theme.shareLink")}</h3>
      <ul className="d-flex list-unstyled mb-0">
        <li>
          <div>
            <Link
              to="https://www.instagram.com/accounts/login/"
              className="d-flex justify-content-center align-items-center"
              target="_blank"
            >
              <em className="icon-instagram" />
            </Link>
          </div>
        </li>
        <li>
          <TwitterShareButton
            url={Url}
            title={text}
            className="Demo__some-network__share-button"
          >
            <Link
              to="#"
              className="d-flex justify-content-center align-items-center"
            >
              <em className="icon-twitter" />
            </Link>
          </TwitterShareButton>
        </li>
        {/* <li>
          <div>
            <Link
              to="https://www.youtube.com/"
              className="d-flex justify-content-center align-items-center"
               target="_blank"
            >
              <em className="icon-youtube" />
            </Link>
          </div>
        </li> */}
        <li>
          <FacebookMessengerShareButton url={Url} title={text}>
            <Link
              to="#"
              className="d-flex justify-content-center align-items-center"
            >
              <em className="icon-facebook" />
            </Link>
          </FacebookMessengerShareButton>
        </li>
        {/* <li>
          <WhatsappShareButton
            url={Url}
            title={text}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <Link
              to="#!"
              className="d-flex justify-content-center align-items-center"
            >
              <WhatsappIcon />
            </Link>
          </WhatsappShareButton>
        </li>
        <li>
          <LinkedinShareButton
            url={Url}
            title={text}
            className="Demo__some-network__share-button"
          >
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </li>
        <li>
          <EmailShareButton
            url={Url}
            subject={text}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </li> */}
      </ul>
    </div>
  );
}

export default WebShare;
